<template>
	<div class="login_block">
		<a class="logo" href="/"></a>
		<div class="login_box">
			<h2>中喆德元电机云</h2>
			<dl>
				<dd>
					<span>用户名</span>
					<el-input class="user" v-model="user"  placeholder="请输入用户名"></el-input>
					<div class="mess">
						<!-- 提示信息 -->
						<em></em>
					</div>
				</dd>
				<dd>
					<span>密码</span>
					<el-input class="password" v-model="password"  placeholder="请输入密码" show-password></el-input>
					<div class="mess">
						<!-- 提示信息 -->
						<em></em>
						<el-checkbox v-model="checked">记住用户名</el-checkbox>
					</div>
				</dd>
				<dd class="mt20">
					<el-button type="primary">主要按钮</el-button>
				</dd>
			</dl>
			<div class="foot"><span>山东中喆德元智能装备有限公司</span></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			user: '',
			password:'',
			checked:false
		}
	},
}
</script>

<style lang="less" scoped>
.login_block{
	width: 100%;
	height: 100%;
	background: url('../images/login_bg.png') center no-repeat;
	position: relative;

	.logo{
		width: 236px;
		height: 74px;
		background: url('../images/logo_login.png') no-repeat;
		position: absolute;
		top: 60px;
		left: 145px;
	}

	.login_box{
		width: 560px;
		background: #fff;
		box-shadow: 0px 0px 10px rgba(19, 117, 191, 0.8);
		padding: 65px 100px 40px;
		border-radius: 5px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50.1%,-50.1%);

		h2{
			color: #000;
			font-size: 30px;
			font-weight: bold;
			text-align: center;
			width: 100%;
			padding-bottom: 25px;
			position: relative;

			&::after{
				content: '';
				width: 50px;
				height: 5px;
				background: #1265a4;
				border-radius: 3px;
				position: absolute;
				left: 50%;
				bottom: 0;
				transform: translate(-50%,0);
			}
		}

		dd{
			width: 100%;

			span{
				color: #666;
				font-size: 20px;
			}
			/deep/.el-input__inner{
				height: 50px;
				border: 1px solid #dde2e8;
				border-radius: 5px;
				margin-top: 10px;
			}
			.user /deep/.el-input__inner{
				background:#f6f7f8 url('../images/ico_06.png') 95% no-repeat;
			}
			.password /deep/.el-input__inner{
				background:#f6f7f8 url('../images/ico_07.png') 95% no-repeat;
			}
			/deep/.el-button{
				width: 100%;
				height: 50px;
				background: #1265a4;
				border: none;
			}
			/deep/.el-input__suffix{
				display: none;
			}

			.mess{
				color: #666;
				width: 100%;
				height: 20px;
				margin-top: 8px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				em{
					font-style: normal;
				}
			}
		}
		.foot{
			width: 100%;
			margin-top: 50px;
			display: flex;
			justify-content: center;

			span{
				color: #7a8c99;
				font-size: 16px;
				position: relative;

				&::before{
					content: '';
					width: 60px;
					height: 1px;
					background: #b6bfc6;
					position: absolute;
					left: -80px;
					top: 10px;
				}
				&::after{
					content: '';
					width: 60px;
					height: 1px;
					background: #b6bfc6;
					position: absolute;
					right: -80px;
					top: 10px;
				}
			}
		}
	}
}
</style>